import ConfirmContactTable from './ConfirmContact'
import SelectEventTable from './SelectEvent'
import ConfirmTable from './Confirm'
import ConfirmColumnTable from './ConfirmColumn'

export default {
	ConfirmColumnTable,
	ConfirmContactTable,
	SelectEventTable,
	ConfirmTable
}
